import type { RoomSummary, RoomView } from '@sw/protocol';
import { create } from 'zustand';

interface RoomState {
  room: RoomView | null;
  publicRooms: RoomSummary[];
  setRoom(r: RoomView | null): void;
  setPublicRooms(r: RoomSummary[]): void;
}

export const useRoom = create<RoomState>((set) => ({
  room: null,
  publicRooms: [],
  setRoom(room) {
    set((s) => (room && s.room && room.code === s.room.code && room.version < s.room.version ? s : { room }));
  },
  setPublicRooms(publicRooms) {
    set({ publicRooms });
  },
}));
